import type { PlaybooksConfigRowMenuItemDescriptor } from './config-page-logic';

export type RungMenuAction = 'edit-conditions' | 'duplicate-segmentation' | 'remove';

export interface RungMenuItemDescriptor extends Omit<PlaybooksConfigRowMenuItemDescriptor, 'action'> {
  action: RungMenuAction;
}

/**
 * QA round 7, U9 (item 16) — the ladder group kebab, as data. Extracted from
 * `QualifyStep.tsx`'s two inline arrays (`RungRow`, `PendingRungRow`) so bun
 * can pin it, matching `sequence-card-menu.ts` / `config-page-logic.ts`.
 *
 * "Duplicate segmentation" REVERSES the round-3 Group F decision (#9, "no
 * Duplicate group") at Spencer's request: it copies the group's SAVED
 * segmentation into a new one ("<name> (copy)", same conditions — the
 * existing `POST /segmentations/:id/duplicate`) and adds that as a new group
 * in this ladder carrying the same sequence mapping. The catch-all has no
 * Duplicate (there is exactly one) and no Remove (it is the floor).
 */
export function getRungMenuItems(rung: { isCatchAll: boolean }): RungMenuItemDescriptor[] {
  if (rung.isCatchAll) return [{ action: 'edit-conditions', label: 'Edit conditions' }];
  return [
    { action: 'edit-conditions', label: 'Edit conditions' },
    { action: 'duplicate-segmentation', label: 'Duplicate segment' },
    { action: 'remove', label: 'Remove group', danger: true },
  ];
}

/**
 * Codex fixes 2026-09-18, F1/F2 — the ONE sentence for both partial outcomes
 * of "Duplicate segmentation" (`QualifyStep.tsx#duplicateAndPersist`): the
 * copy IS in the Library, this ladder was NOT changed. Named here, in the
 * pure module this menu already lives in, so the two vitest cases and the
 * component read one string. Points at "Add segmentation" on purpose — a
 * second "Duplicate" would mint a second orphan copy, not retry attaching
 * the first.
 */
export const DUPLICATE_SEGMENTATION_COPY_ONLY_MESSAGE =
  'The copy was saved to the Library, but this play’s groups weren’t changed. Use "Add segment" to add it — duplicating again would make a second copy.';
